(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function(root, factory) {

  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = factory(root, exports);
    }
  } else if (typeof define === 'function' && define.amd) {
    define(['exports'], function(exports) {
      root.Lockr = factory(root, exports);
    });
  } else {
    root.Lockr = factory(root, {});
  }

}(this, function(root, Lockr) {
  'use strict';

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(elt /*, from*/)
    {
      var len = this.length >>> 0;

      var from = Number(arguments[1]) || 0;
      from = (from < 0)
      ? Math.ceil(from)
      : Math.floor(from);
      if (from < 0)
        from += len;

      for (; from < len; from++)
      {
        if (from in this &&
            this[from] === elt)
          return from;
      }
      return -1;
    };
  }

  Lockr.prefix = "";

  Lockr._getPrefixedKey = function(key, options) {
    options = options || {};

    if (options.noPrefix) {
      return key;
    } else {
      return this.prefix + key;
    }

  };

  Lockr.set = function (key, value, options) {
    var query_key = this._getPrefixedKey(key, options);

    try {
      localStorage.setItem(query_key, JSON.stringify({"data": value}));
    } catch (e) {
      if (console) console.warn("Lockr didn't successfully save the '{"+ key +": "+ value +"}' pair, because the localStorage is full.");
    }
  };

  Lockr.get = function (key, missing, options) {
    var query_key = this._getPrefixedKey(key, options),
        value;

    try {
      value = JSON.parse(localStorage.getItem(query_key));
    } catch (e) {
            if(localStorage[query_key]) {
              value = {data: localStorage.getItem(query_key)};
            } else{
                value = null;
            }
    }
    
    if(!value) {
      return missing;
    }
    else if (typeof value === 'object' && typeof value.data !== 'undefined') {
      return value.data;
    }
  };

  Lockr.sadd = function(key, value, options) {
    var query_key = this._getPrefixedKey(key, options),
        json;

    var values = Lockr.smembers(key);

    if (values.indexOf(value) > -1) {
      return null;
    }

    try {
      values.push(value);
      json = JSON.stringify({"data": values});
      localStorage.setItem(query_key, json);
    } catch (e) {
      console.log(e);
      if (console) console.warn("Lockr didn't successfully add the "+ value +" to "+ key +" set, because the localStorage is full.");
    }
  };

  Lockr.smembers = function(key, options) {
    var query_key = this._getPrefixedKey(key, options),
        value;

    try {
      value = JSON.parse(localStorage.getItem(query_key));
    } catch (e) {
      value = null;
    }
    
    return (value && value.data) ? value.data : [];
  };

  Lockr.sismember = function(key, value, options) {
    return Lockr.smembers(key).indexOf(value) > -1;
  };

  Lockr.keys = function() {
    var keys = [];
    var allKeys = Object.keys(localStorage);

    if (Lockr.prefix.length === 0) {
      return allKeys;
    }

    allKeys.forEach(function (key) {
      if (key.indexOf(Lockr.prefix) !== -1) {
        keys.push(key.replace(Lockr.prefix, ''));
      }
    });

    return keys;
  };

  Lockr.getAll = function (includeKeys) {
    var keys = Lockr.keys();

    if (includeKeys) {
      return keys.reduce(function (accum, key) {
        var tempObj = {};
        tempObj[key] = Lockr.get(key);
        accum.push(tempObj);
        return accum;
      }, []);
    }

    return keys.map(function (key) {
      return Lockr.get(key);
    });
  };

  Lockr.srem = function(key, value, options) {
    var query_key = this._getPrefixedKey(key, options),
        json,
        index;

    var values = Lockr.smembers(key, value);

    index = values.indexOf(value);

    if (index > -1)
      values.splice(index, 1);

    json = JSON.stringify({"data": values});

    try {
      localStorage.setItem(query_key, json);
    } catch (e) {
      if (console) console.warn("Lockr couldn't remove the "+ value +" from the set "+ key);
    }
  };

  Lockr.rm =  function (key) {
    var queryKey = this._getPrefixedKey(key);
    
    localStorage.removeItem(queryKey);
  };

  Lockr.flush = function () {
    if (Lockr.prefix.length) {
      Lockr.keys().forEach(function(key) {
        localStorage.removeItem(Lockr._getPrefixedKey(key));
      });
    } else {
      localStorage.clear();
    }
  };
  return Lockr;

}));

},{}],2:[function(require,module,exports){
'use strict';

var iFrame = function iFrame() {
	this.params = {};
	this.form = null;
	this.iframe = null;
};
iFrame.prototype = {
	initialize: function initialize(params) {
		if (typeof params != 'object') {
			throw "Object is not defined.";
		}
		this.removeItems();
		this.params = Object.assign({}, this.params, params);
		this.form = $('<form action="' + this.params.action_url + '" target="leadgrab-iframe" method="post" style="display:none;" id="leadgrab-form" name="leadgrab-form"></form>');
		this.iframe = $('<iframe style="display:none; border:none;" id="leadgrab-iframe" name="leadgrab-iframe" src="' + this.params.action_url + '"></iframe>');
		$("body").append(this.form).append(this.iframe);
		this.loadFields();
		return this;
	},
	removeItems: function removeItems() {
		$('#leadgrab-form').remove();
		$('#leadgrab-iframe').remove();
	},
	loadFields: function loadFields() {
		for (var i = 0; i < this.params.fields.length; i++) {
			this.addField(this.params.fields[i]);
		}
	},
	addField: function addField(input) {
		$("<input />").attr("type", input.type).attr("name", input.name).attr("value", input.value).appendTo(this.form);
	},
	submit: function submit(callback) {
		this.form.submit();
		this.iframe.on('load', $.proxy(function () {
			this.removeItems();
			if (typeof callback == 'function') {
				callback();
			}
		}, this));
	}
};

module.exports = iFrame;

},{}],3:[function(require,module,exports){
'use strict';

var Lockr = require('lockr');
var iFrame = require('./iFrame');

(function ($) {
	//////////////////////////// CSRF //////////////////////////////////////////
	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});
	//////////////////////// SNIPPET //////////////////////////////////////////
	var Snippet = function Snippet(settings) {
		this.settings = settings;
		this.base_template = _.template("<div style='display:none;' class='ab-preview-container <%=position %>'><%=contents %></div>");
		this.full_template = _.template("<div style='display:none;' class='ab-preview-container full_width'><%=contents %></div>");
		if (this.settings.brand_photo.indexOf('default.gif') < 0) {
			this.button_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div class="sc-button" style="padding-top:2px;"><a class="button" id="click_binder" data-href="<%=button_url %>" style="background-color:<%=action_color %>; color:<%=action_text_color %>;"><%=button_text %></a></div></div></div></div>');
			this.link_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div style="padding-top:13px;"><a data-href="<%=link_url %>" id="click_binder" style="color:<%=action_color %>;"><%=link_text %></a></div></div></div></div>');
			this.form_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"><a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="#" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="#" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div class="sc-button sc-with-email sc-email-type-3"><div class="sc-input-email"><input id="sc-input-email" placeholder="Email Address" type="email"/><a id="submit_form" class="button" href="javascript:void(0)" style="background-color:<%=action_color %>; color:<%=action_text_color %>;">Send </a></div></div></div></div></div>');

			if (this.settings.theme == '3A' || this.settings.theme == '3B' || this.settings.theme == '3C' || this.settings.theme == '3D') {
				this.button_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div class="sc-button" style="padding-top:2px;"><a class="button" id="click_binder" data-href="<%=button_url %>" style="background-color:<%=action_color %>; color:<%=action_text_color %>;"><%=button_text %></a></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
				this.link_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div style="padding-top:13px;" class="sc-button"><a data-href="<%=link_url %>" id="click_binder" style="color:<%=action_color %>;"><%=link_text %></a></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
				this.form_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"><a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>-/scale_crop/100x95/"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div class="sc-button sc-with-email sc-email-type-3"><div class="sc-input-email"><input id="sc-input-email" placeholder="Email Address" type="email"/><a id="submit_form" class="button" href="javascript:void(0)" style="background-color:<%=action_color %>; color:<%=action_text_color %>;">Send </a></div></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="#" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="#" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
			}
		} else {
			this.button_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div class="sc-button" style="padding-top:2px;"><a class="button" id="click_binder" data-href="<%=button_url %>" style="background-color:<%=action_color %>; color:<%=action_text_color %>;"><%=button_text %></a></div></div></div></div>');
			this.link_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div style="padding-top:13px;"><a data-href="<%=link_url %>" id="click_binder" style="color:<%=action_color %>;"><%=link_text %></a></div></div></div></div>');
			this.form_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"><a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="#" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="#" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div><div class="sc-button sc-with-email sc-email-type-3"><div class="sc-input-email"><input id="sc-input-email" placeholder="Email Address" type="email"/><a id="submit_form" class="button" href="javascript:void(0)" style="background-color:<%=action_color %>; color:<%=action_text_color %>;">Send </a></div></div></div></div></div>');
			if (this.settings.theme == '3A' || this.settings.theme == '3B' || this.settings.theme == '3C' || this.settings.theme == '3D') {
				this.button_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div class="sc-button" style="padding-top:2px;"><a class="button" id="click_binder" data-href="<%=button_url %>" style="background-color:<%=action_color %>; color:<%=action_text_color %>;"><%=button_text %></a></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
				this.link_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"> <a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div style="padding-top:13px;" class="sc-button"><a data-href="<%=link_url %>" id="click_binder" style="color:<%=action_color %>;"><%=link_text %></a></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="javascript:void(0)" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="javascript:void(0)" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
				this.form_type_template = _.template('<div class="snipper-container" id="theme-<%=theme %>"><a class="close-snippet"><i class="icon close"></i></a><div class="sc-avatar"><img src="<%=brand_photo %>"></div><div class="sc-main" style="background-color:<%=background_color %>;"><div class="sc-details"><div class="sc-name"><strong><a href="javascript:void(0)" style="color:<%=text_color %>;"><%=brand_name %></a></strong></div><div class="sc-message"><p style="color:<%=text_color %>;"><%=message %></p><div class="sc-button sc-with-email sc-email-type-3"><div class="sc-input-email"><input id="sc-input-email" placeholder="Email Address" type="email"/><a id="submit_form" class="button" href="javascript:void(0)" style="background-color:<%=action_color %>; color:<%=action_text_color %>;">Send </a></div></div></div></div><div class="sc-button-group"><div class="sc-social-buttons"><a class="facebook" href="#" data-facebook="<%=facebook_text %>"><i class="icon facebook"></i></a><a class="twitter" href="#" data-facebook="<%=twitter_text %>"><i class="icon twitter"></i></a></div></div></div></div>');
			}
		}

		this.parent = 'body';
	};
	Snippet.prototype = {
		initialize: function initialize() {
			var contents;
			switch (this.settings.type) {
				case 'image':
					contents = '<div class="snipper-container" style="width:729px;height:90px; padding:0px;" id="theme-' + this.settings.theme + '"><a class="close-snippet"><i class="icon close"></i></a><a href="javascript:void(0)" id="click_binder"><img src=" ' + this.settings.image_url + ' " /></a></div>';
					break;
				case 'form':
					contents = this.form_type_template(this.settings);
					break;
				case 'link':
					contents = this.link_type_template(this.settings);
					break;
				case 'button':
					contents = this.button_type_template(this.settings);
					break;
			}
			// Track Visitor Upfront
			this.track_visitor();
			// Renders the Snippet itself
			return this.create_snippet(contents);
		},
		create_snippet: function create_snippet(contents) {
			this.settings.contents = contents;
			var template = this.base_template(this.settings);
			if (this.settings.theme == '3A' || this.settings.theme == '3B' || this.settings.theme == '3C' || this.settings.theme == '3D') {
				template = this.full_template(this.settings);
			}

			$(this.parent).append(template);
			setTimeout($.proxy(function () {
				if (this.settings.theme == '3A' || this.settings.theme == '3B' || this.settings.theme == '3C' || this.settings.theme == '3D') {
					$('.ab-preview-container').css(this.get_right_positions());
				}
				$('.ab-preview-container').fadeIn();
			}, this), 1500);
			return this.create_bindings();
		},
		get_right_positions: function get_right_positions() {
			if (this.settings.theme == '3A' && this.isTop()) {
				return {
					top: 0,
					height: '60px',
					width: '100%'
				};
			} else if (this.settings.theme == '3A' && this.isBottom()) {
				return {
					bottom: 0,
					height: '60px',
					width: '100%'
				};
			} else if (this.settings.theme == '3B' && this.isTop()) {
				return {
					top: 25,
					height: '60px',
					width: '100%'
				};
			} else if (this.settings.theme == '3C' && this.isTop()) {
				return {
					top: 0,
					height: '60px',
					width: '100%'
				};
			} else if (this.settings.theme == '3D' && this.isBottom()) {
				return {
					bottom: 3,
					height: '60px',
					width: '100%'
				};
			} else if (this.settings.theme == '3D' && this.isTop()) {
				return {
					top: '-4px',
					height: '60px',
					width: '100%'
				};
			}
		},
		isTop: function isTop() {
			return this.settings.position == 'top-left' || this.settings.position == 'top-right' ? true : false;
		},
		isBottom: function isBottom() {
			return this.settings.position == 'bottom-left' || this.settings.position == 'bottom-right' ? true : false;
		},
		create_bindings: function create_bindings() {
			switch (this.settings.type) {
				case 'image':
					this.create_close_binding();
					this.create_social_bindings();
					return this.create_image_bindings();
					break;
				case 'form':
					this.create_close_binding();
					this.create_social_bindings();
					return this.create_form_bindings();
					break;
				case 'link':
					this.create_close_binding();
					this.create_social_bindings();
					return this.create_link_bindings();
					break;
				case 'button':
					this.create_close_binding();
					this.create_social_bindings();
					return this.create_button_bindings();
					break;
			}
		},
		create_close_binding: function create_close_binding() {
			$('.close-snippet').css('cursor', 'pointer').on('click', $.proxy(function () {
				window.location.href = this.settings.url;
			}, this));
		},
		create_image_bindings: function create_image_bindings() {
			$('#click_binder').on('click', $.proxy(function () {
				this.track_click().done($.proxy(function () {
					window.location.href = this.settings.image_action_url;
				}, this));
			}, this));
		},
		create_form_bindings: function create_form_bindings() {
			var button = $('#submit_form');
			var email = $('#sc-input-email');
			email.on('keyup', $.proxy(function (ev) {
				email.removeAttr('style');
				if (ev.which == 13 || ev.keyCode == 13) {
					this.submit_email_form_handler(email.val());
				}
			}, this));
			button.on('click', $.proxy(function (ev) {
				this.submit_email_form_handler(email.val());
			}, this));
		},
		submit_email_form_handler: function submit_email_form_handler(email) {
			if (!this.validate_email(email)) {
				$('#sc-input-email').css('border-color', '#FFC8C8');
				$('#sc-input-email').css('background-color', 'rgb(255, 200, 200)');
				return false;
			}
			$('#sc-input-email').attr('disabled', true);
			$('#submit_form').text("Sending...");
			///////////////////////////////////////////////////////////////////////
			if (this.settings.is_raw == true) {
				console.log("Submitting through iframe....");
				return this.submit_email_form_iframe(email);
			}
			console.log("Submitting through rest API....");
			return this.submit_email_form(email);
		},
		submit_email_form_iframe: function submit_email_form_iframe(email) {
			var options = {
				action_url: this.settings.form.action_url,
				fields: this.getFormFields(email)
			};
			var form = new iFrame();
			form.initialize(options).submit($.proxy(function () {
				this.track_conversion().done($.proxy(function () {
					this.track_click().done($.proxy(function () {
						window.location.href = this.settings.url;
					}, this));
				}, this));
			}, this));
		},
		getFormFields: function getFormFields(email) {
			var fields = [];
			var email_field = this.settings.form.email_field;
			for (var i = 0; i < this.settings.form.fields.length; i++) {
				if (email_field == this.settings.form.fields[i].name) {
					this.settings.form.fields[i].value = email;
				}
				fields.push(this.settings.form.fields[i]);
			}
			return fields;
		},
		submit_email_form: function submit_email_form(email) {
			$.ajax({
				type: "POST",
				url: "/api/tracker/subscribe",
				data: { email: email, campaign_id: this.settings.cid },
				error: function error(_error) {
					$('#sc-input-email').css('border-color', '#FFC8C8');
					$('#sc-input-email').css('background-color', 'rgb(255, 200, 200)');
					$('#submit_form').text("Send");
					$('#sc-input-email').removeAttr('disabled');
				},
				success: $.proxy(function () {
					this.track_conversion().done($.proxy(function () {
						this.track_click().done($.proxy(function () {
							window.location.href = this.settings.url;
						}, this));
					}, this));
				}, this)
			});
		},
		validate_email: function validate_email(email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		create_button_bindings: function create_button_bindings() {
			$('#click_binder').on('click', $.proxy(function () {
				this.track_click().done($.proxy(function () {
					window.location.href = this.settings.button_url;
				}, this));
			}, this));
		},
		create_link_bindings: function create_link_bindings() {
			$('#click_binder').on('click', $.proxy(function () {
				this.track_click().done($.proxy(function () {
					window.location.href = this.settings.link_url;
				}, this));
			}, this));
		},
		create_social_bindings: function create_social_bindings() {
			if (!this.settings.sharing) {
				$('.sc-social-buttons').css('visibility', 'hidden');
				return false;
			}
			var facebook = $('.sc-social-buttons').find('a.facebook');
			var twitter = $('.sc-social-buttons').find('a.twitter');
			facebook.on('click', $.proxy(this.share_on_facebook, this));
			twitter.on('click', $.proxy(this.share_on_twitter, this));
		},
		share_on_twitter: function share_on_twitter() {
			var share_url = this.create_twitter_url();
			window.open(share_url, 'Share On Twitter', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
			return false;
		},
		create_twitter_url: function create_twitter_url() {
			var base = 'https://twitter.com/share?';
			if (this.settings.twitter_text == '') {
				base += 'text=' + encodeURIComponent(this.settings.message);
			} else {
				base += 'text=' + encodeURIComponent(this.settings.twitter_text);
			}
			return base;
		},
		share_on_facebook: function share_on_facebook() {
			var settings = {
				title: this.settings.brand_name,
				url: this.settings.short_url,
				image: this.settings.brand_photo
			};
			var share_url = this.create_facebook_url(settings);
			window.open(share_url, 'Share On Facebook', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
			return false;
		},
		create_facebook_url: function create_facebook_url(settings) {
			var baseUrl = 'http://www.facebook.com/sharer.php?s=100&p';
			baseUrl += '[title]=' + encodeURIComponent(settings.title) + '&p';
			baseUrl += '[url]=' + encodeURIComponent(settings.url) + '&p';
			if (this.settings.facebook_text == '') {
				baseUrl += '[summary]=' + encodeURIComponent(this.settings.message + ' ' + settings.short_url) + '&p';
			} else {
				baseUrl += '[summary]=' + encodeURIComponent(this.settings.facebook_text + ' ' + settings.short_url) + '&p';
			}
			baseUrl += '[images][0]=' + encodeURIComponent(settings.image);
			return baseUrl;
		},
		track_click: function track_click() {
			var deferred = $.Deferred();
			if (this.settings.type != 'image') {
				$('#click_binder').text('Please Wait...');
			} else {
				$('.snipper-container').fadeOut('fast');
			}
			$.ajax({
				type: "POST",
				url: "/api/tracker/click",
				data: { campaign_id: this.settings.cid },
				success: $.proxy(function () {
					deferred.resolve();
				}, this)
			});
			return deferred.promise();
		},
		track_conversion: function track_conversion() {
			var deferred = $.Deferred();
			$.ajax({
				type: "POST",
				url: "/api/tracker/conversion",
				data: { campaign_id: this.settings.cid },
				success: $.proxy(function () {
					deferred.resolve();
				}, this)
			});
			return deferred.promise();
		},
		track_visitor: function track_visitor() {
			var deferred = $.Deferred();
			$.ajax({
				type: "POST",
				url: "/api/tracker/visitor",
				data: { campaign_id: this.settings.cid },
				success: $.proxy(function () {
					console.log("Visitor has been tracked...");
					deferred.resolve();
				}, this)
			});
			return deferred.promise();
		}
	};
	/////////////// Initialize application
	$('#main_frame').on('load', function () {
		var lg = new Snippet(LEADGRAB.SETTINGS);
		lg.initialize();
	});
})(jQuery);

},{"./iFrame":2,"lockr":1}]},{},[3]);
